import { Typography } from "antd";
import React from "react";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

const CurrentSubscription = ({ subscription }) => {
  return (
    <>
      {subscription === "standard" ? (
        <div style={{ maxWidth: 320, width: "100%" }}>
          <div
            style={{
              position: "relative",
              backgroundColor: "#fff",
              borderRadius: 40,
              border: "1px solid #e5e5e5",
              zIndex: 2,
              margin: 8,
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <Typography
              style={{
                fontSize: 36,
                fontWeight: "bold",
                color: "#d15d46",
                textAlign: "center",
              }}
            >
              Standard
            </Typography>
            <Typography
              style={{
                fontSize: 16,
                fontWeight: "bold",
                color: "#473a58",
                textAlign: "center",
                marginBottom: 10,
              }}
            >
              Current Subscription
            </Typography>
            <div
              style={{ borderBottom: "1px solid #e5e5e5", marginBottom: 10 }}
            />
            <Typography
              style={{ fontSize: 18, textAlign: "center", fontWeight: "bold" }}
            >
              Features
            </Typography>
            <div
              style={{
                paddingLeft: 10,
                paddingRight: 10,
                marginTop: 10,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Custom QR Code Menu
                </Typography>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Up to 30 SKU's
                </Typography>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Ordering System
                </Typography>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Unlimited Transactions
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 5,
                }}
              >
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  2 Accounts/Users
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 5,
                }}
              >
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <div>
                  <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                    Sales Reports
                  </Typography>
                  <Typography style={{ fontSize: 10, fontWeight: "bold" }}>
                    Daily/Weekly/Monthly/Yearly
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <CloseCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#aeaeae",
                    fontSize: 16,
                  }}
                />
                <div>
                  <Typography style={{ fontSize: 14, color: "#aeaeae" }}>
                    Inventory Reports
                  </Typography>
                  <Typography style={{ fontSize: 10, color: "#aeaeae" }}>
                    Daily/Weekly/Monthly/Yearly
                  </Typography>
                </div>
              </div>
            </div>
            <div
              style={{
                backgroundColor: "#473a58",
                padding: 10,
                borderRadius: 20,
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <Typography
                style={{
                  fontSize: 18,
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                Free Services
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 10,
                }}
              >
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#fff",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, color: "#fff" }}>
                  Onsite Visit
                </Typography>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#fff",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, color: "#fff" }}>
                  Online Support
                </Typography>
              </div>
            </div>
          </div>
          <div
            style={{
              position: "relative",
              backgroundColor: "#d15d46",
              height: 300,
              borderRadius: 40,
              zIndex: 1,
              marginTop: -280,
            }}
          />
        </div>
      ) : subscription === "premium" ? (
        <div style={{ maxWidth: 320, width: "100%" }}>
          <div
            style={{
              position: "relative",
              backgroundColor: "#fff",
              borderRadius: 40,
              border: "1px solid #e5e5e5",
              zIndex: 2,
              margin: 8,
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <Typography
              style={{
                fontSize: 40,
                fontWeight: "bold",
                color: "#d15d46",
                textAlign: "center",
              }}
            >
              Premium
            </Typography>
            <Typography
              style={{
                fontSize: 18,
                fontWeight: "bold",
                color: "#473a58",
                textAlign: "center",
                marginBottom: 10,
              }}
            >
              Current Subscription
            </Typography>
            <div
              style={{ borderBottom: "1px solid #e5e5e5", marginBottom: 10 }}
            />
            <Typography
              style={{ fontSize: 18, textAlign: "center", fontWeight: "bold" }}
            >
              Features
            </Typography>
            <div
              style={{
                paddingLeft: 10,
                paddingRight: 10,
                marginTop: 10,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Custom QR Code Menu
                </Typography>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Unlimited SKU's
                </Typography>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Ordering System
                </Typography>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Unlimited Transactions
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 5,
                }}
              >
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Unlimited Accounts/Users
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 5,
                }}
              >
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <div>
                  <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                    Sales Reports
                  </Typography>
                  <Typography style={{ fontSize: 10, fontWeight: "bold" }}>
                    Daily/Weekly/Monthly/Yearly
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <div>
                  <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                    Inventory Reports
                  </Typography>
                  <Typography style={{ fontSize: 10, fontWeight: "bold" }}>
                    Daily/Weekly/Monthly/Yearly
                  </Typography>
                </div>
              </div>
            </div>
            <div
              style={{
                backgroundColor: "#473a58",
                padding: 10,
                borderRadius: 20,
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <Typography
                style={{
                  fontSize: 18,
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                Free Services
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 10,
                }}
              >
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#fff",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, color: "#fff" }}>
                  Onsite Visit (Davao City)
                </Typography>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 5,
                }}
              >
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#fff",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, color: "#fff" }}>
                  Dedicated Online Support
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 5,
                }}
              >
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#fff",
                    fontSize: 16,
                  }}
                />
                <div>
                  <Typography style={{ fontSize: 14, color: "#fff" }}>
                    Online/Onsite Customer
                  </Typography>
                  <Typography style={{ fontSize: 10, color: "#fff" }}>
                    Service Training & Consulting
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              position: "relative",
              backgroundColor: "#d15d46",
              height: 300,
              borderRadius: 40,
              zIndex: 1,
              marginTop: -280,
            }}
          />
        </div>
      ) : (
        <div style={{ maxWidth: 320, width: "100%" }}>
          <div
            style={{
              position: "relative",
              backgroundColor: "#fff",
              borderRadius: 40,
              border: "1px solid #e5e5e5",
              zIndex: 2,
              margin: 8,
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <Typography
              style={{
                fontSize: 36,
                fontWeight: "bold",
                color: "#473a58",
                textAlign: "center",
              }}
            >
              Trial
            </Typography>
            <Typography
              style={{
                fontSize: 16,
                fontWeight: "bold",
                color: "#473a58",
                textAlign: "center",
                marginBottom: 10,
              }}
            >
              Current Subscription
            </Typography>
            <div
              style={{ borderBottom: "1px solid #e5e5e5", marginBottom: 10 }}
            />
            <Typography
              style={{ fontSize: 18, textAlign: "center", fontWeight: "bold" }}
            >
              Features
            </Typography>
            <div
              style={{
                paddingLeft: 10,
                paddingRight: 10,
                marginTop: 10,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Custom QR Code Menu
                </Typography>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Up to 5 SKU's
                </Typography>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Ordering System
                </Typography>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  Unlimited Transactions
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 5,
                }}
              >
                <CheckCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#000",
                    fontSize: 16,
                  }}
                />
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  1 Accounts/Users
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 5,
                }}
              >
                <CloseCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#aeaeae",
                    fontSize: 16,
                  }}
                />
                <div>
                  <Typography style={{ fontSize: 14, color: "#aeaeae" }}>
                    Sales Reports
                  </Typography>
                  <Typography style={{ fontSize: 10, color: "#aeaeae" }}>
                    Daily/Weekly/Monthly/Yearly
                  </Typography>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <CloseCircleOutlined
                  style={{
                    marginRight: 10,
                    color: "#aeaeae",
                    fontSize: 16,
                  }}
                />
                <div>
                  <Typography style={{ fontSize: 14, color: "#aeaeae" }}>
                    Inventory Reports
                  </Typography>
                  <Typography style={{ fontSize: 10, color: "#aeaeae" }}>
                    Daily/Weekly/Monthly/Yearly
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              position: "relative",
              backgroundColor: "#473a58",
              height: 300,
              borderRadius: 40,
              zIndex: 1,
              marginTop: -280,
            }}
          />
        </div>
      )}
    </>
  );
};

export default CurrentSubscription;
